import { Box, Tooltip } from "@mui/material";

interface CardReferenceTagProps {
  color: string;
  tooltip?: string;
}

const CardReferenceTag: React.FC<CardReferenceTagProps> = ({
  color,
  tooltip,
}) => {
  const renderTag = () => {
    return (
      <Box sx={{ backgroundColor: color, width: "10px", height: "10px",borderRadius:'2px' }}></Box>
    );
  };

  return (
    <>
      {tooltip ? <Tooltip title={tooltip}>{renderTag()}</Tooltip> : renderTag()}
    </>
  );
};

export default CardReferenceTag;
